(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/maltipset/assets/javascripts/init.js') >= 0) return;  svs.modules.push('/modules/maltipset/assets/javascripts/init.js');

(function(Backbone, svs) {
  'use strict';

  var App = Marionette.Application.extend({
    region: '#maltipsetMain',

    onStart: function() {
      if (svs.core.detect.formfactor.mobile()) {
        var cmsDefaultTab = svs.maltipset.data.config.startPageConfig.defaultTab;
        if (cmsDefaultTab && !window.location.search) {
          window.location.href = '?flik=' + cmsDefaultTab;
          return;
        }
      }

      this.skeleton = new Marionette.View({
        template: svs.maltipset.templates.maltipset,
        regions: {
          mainRegion: '#maltipset',
          betslip: '#betslip-wrapper'
        }
      });

      this.showView(this.skeleton);

      svs.maltipset.router = new svs.maltipset.Router();
      svs.maltipset.controllers.maltipsetController = new svs.maltipset.controllers.MaltipsetController(this);

      if (svs.maltipset.collections.draws.length > 0) {
        Backbone.history.start({
          pushState: true,
          root: svs.core.data.baseUrl
        });
      } else {
        svs.maltipset.app.skeleton
          .getRegion('mainRegion')
          .show(new svs.maltipset.views.Play());
      }
    }
  });

  svs.maltipset.app = new App();
  svs.maltipset.app.start();
})(Backbone, svs);


 })(window);